/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import MISC from '@/js/miscellaneous.js'
import PARSE from '@/js/parse.js'

const ipLoopBack = `${process.env.VUE_APP_URL}`

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

function comm (base64Bytes, address, kwargs = {}) {
  return new Promise(function (resolve, reject) {
    try {
      fetch(
        address,
        {
          method: 'POST',
          mode: 'cors',
          body: base64Bytes ? JSON.stringify({data: base64Bytes, ...kwargs}) : JSON.stringify({...kwargs}),
          headers:{
            'Content-Type': 'application/json'
          },
          timeout: 30
        }
      ).then((response) => { return response.json();}
      ).then((ret) => {
        if (ret.code != 0) {
          reject('인식 서버 오류, code: ' + ret.code)
          return
        }
        resolve(ret)
      }).catch(error => reject(error + ''));
    } catch (e) {
      reject('timeout')
    }
  })
}

async function recognizeImpl (file, address, kwargs = {}) {
  const base64Bytes = await toBase64(file);
  const ret = await comm(base64Bytes, address, kwargs);
  
  if (ret.data.words == undefined)
    throw 'invalid response'
  let pred = []
  for (let i in ret.data.words) {
    let datum = ret.data.words[i]
    pred.push({
      id: datum.id, text: datum.text, prob: datum.probability,
      active: true,
      highlight: false,
      points: [
        {x: datum.box[0][0], y: datum.box[0][1]},
        {x: datum.box[1][0], y: datum.box[1][1]},
        {x: datum.box[2][0], y: datum.box[2][1]},
        {x: datum.box[3][0], y: datum.box[3][1]},
      ]
    });
  }

  const image_jpeg = MISC.convertBase64ToBuffer(ret.image);
  const image = await PARSE.parseJpg(image_jpeg);
  
  return {pred, data: ret.data, image, image_jpeg};
}

async function recognize (file) {
  if (file == null) { // health check
    const ret = await comm(null, `${ipLoopBack}/api/inference`);
    return ret;
  }

  const ret = await recognizeImpl(file, `${ipLoopBack}/api/inference`)
  return ret
}

async function recognizeHWR (file) {
  if (file == null) { // health check
    const ret = await comm(null, `${ipLoopBack}/api/hwr2`);
    return ret;
  }

  const ret = await recognizeImpl(file, `${ipLoopBack}/api/hwr2`)
  return ret
}

async function recognizeDocument (file) {
  if (file == null) { // health check
    const ret = await comm(null, `${ipLoopBack}/api/ocr/document/inference`);
    return ret;
  }

  const ret = await recognizeImpl(file, `${ipLoopBack}/api/ocr/document/inference`)
  return ret
}

async function recognizePaddle (file, language) {
  if (file == null) { // health check
    const ret = await comm(null, `${ipLoopBack}/api/ocr/paddle/inference`, { language });
    return ret;
  }

  const ret = await recognizeImpl(file, `${ipLoopBack}/api/ocr/paddle/inference`, { language })
  return ret
}

export default {
  recognize,
  recognizeHWR,
  recognizeDocument,
  recognizePaddle
}
